var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    {
      attrs: { cols: _vm.cols, sm: _vm.sm, md: _vm.md, lg: _vm.lg, xl: _vm.xl },
    },
    [
      _c(
        "div",
        { staticClass: "font-weight-regular body-2 text-no-wrap" },
        [
          _vm._v(" " + _vm._s(_vm.title) + " "),
          _vm.$slots.tooltip
            ? _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              "v-icon",
                              _vm._g({ staticClass: "grey--text" }, on),
                              [_vm._v(_vm._s(_vm.icon_help))]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3472553246
                  ),
                },
                [
                  _vm.loading
                    ? _c("v-progress-circular", {
                        attrs: {
                          indeterminate: "",
                          size: "28",
                          width: "2",
                          color: "dark",
                        },
                      })
                    : _vm.error
                    ? _c("div", [_vm._v(" Ошибка ")])
                    : _c("div", [_vm._t("tooltip")], 2),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "headline" },
        [
          _vm.loading
            ? _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  size: "28",
                  width: "2",
                  color: "dark",
                },
              })
            : _vm.error
            ? _c("div", [_vm._v(" Ошибка ")])
            : _vm.$slots.default
            ? _c("div", [_vm._t("default")], 2)
            : _c("div", [
                _vm._v(" " + _vm._s(+parseFloat(_vm.value).toFixed(2))),
                _c("span", { staticClass: "text--secondary" }, [
                  _vm._v(_vm._s(_vm.suffix)),
                ]),
              ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }